module.exports = __webpack_public_path__ + "media/images/admin/dropzone/upload-360c50d9fe8d1954e7a79a2d8c312a48.png";